import styled from "@emotion/styled";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import { makeStyles } from "@mui/styles";
import { globalColors } from "../../../Utils/colors";

interface RadioButtonsDataProviderType {
  label: string;
  value: string;
}

interface RadioButtonsGroupProps {
  dataProvider: RadioButtonsDataProviderType[];
  value: string;
  setValue: (value: string) => void;
}

const useStyles = makeStyles({
  radio: {
    "&$checked": {
      color: globalColors.primary,
    },
  },
  checked: {},
});

export const LabelContainer = styled("div")({
  fontFamily: "Poppins",
  fontSize: "12px",
});

export default function RadioButtonsGroup({
  dataProvider,
  value,
  setValue,
}: RadioButtonsGroupProps) {
  const classes = useStyles();

  return (
    <FormControl>
      <RadioGroup
        row
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      >
        {dataProvider.map((item: RadioButtonsDataProviderType) => {
          return (
            <FormControlLabel
              key={item.value}
              value={item.value}
              label={<LabelContainer>{item.label}</LabelContainer>}
              control={
                <Radio
                  disableRipple
                  classes={{ root: classes.radio, checked: classes.checked }}
                />
              }
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
